const captionCls = "_b7nc8vwhsf";
const contentCls = "_b7nc1gv3cv";
const titleCls = "_b7nt1le0zul";
const spanCls = "_b7nsfqz4xr";

export { captionCls, contentCls, spanCls, titleCls };
import "./caption.slider.style.linaria.module.css";
//# sourceMappingURL=caption.slider.style.js.map
